import { Controller } from '@hotwired/stimulus'

// 費目解説モーダルを開く「セクション側」の共通コントローラ。
// モーダル本体はページに1つだけ描画されるため、?ボタンのクリックは
// window カスタムイベントに変換して渡す（費目ごとにモーダルを複製しない）。
//
// 料金プランセクション（Site::Parts::Facility::Plans）と
// 公的施設ページの料金費用セクション（Site::Pages::Facility::Basic::Cost）が継承して使う。
//
// 使うのはSPのみ。PCはホバー表示（Site::Parts::QuestionHover）で解説を出すため、
// ?ボタンのStimulus action もイベント名の value もサーバ側で出力されない。
export default class extends Controller {
  static values = {
    // 費目解説モーダルを開くイベント名（Ruby側の定数が単一のソース）
    feeDescriptionEvent: String,
  }

  // 押された費目を detail で渡し、モーダル側で該当項目までスクロールさせる
  openFeeDescription (event) {
    // PCはイベント名の value を出力しないため、万一 action だけが配線されても
    // new CustomEvent('') で例外にならないよう抜ける
    if (!this.feeDescriptionEventValue) return

    const slug = event.currentTarget.dataset.feeSlug

    window.dispatchEvent(new CustomEvent(this.feeDescriptionEventValue, { detail: { slug } }))
  }
}
